import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

const DEFAULT_PARAMS = { limit: 10, offset: 0 }

const useCustomerLocations = (
  customerId,
  { queryString, params: inParams = {} } = {}
) => {
  const baseUrl = `/api/customer/${customerId}/location`

  const [customerLocations, setCustomerLocations] = useState([])
  const [customerLocationsCopy, setCustomerLocationsCopy] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const params = { ...DEFAULT_PARAMS, ...(inParams || {}) }

  const getCustomerLocations = () => {
    if (customerId === 'new') {
      setCustomerLocations([])
      setCustomerLocationsCopy([])
      return setIsLoading(false)
    }
    if (!customerId) return

    setIsLoading(true)
    let url = baseUrl
    if (queryString) url += `?query=${queryString}`

    Object.keys(params).forEach((key) => {
      const value = params[key]
      const char = url.includes('?') ? '&' : '?'
      url += `${char}${key}=${value}`
    })

    return authedAxios
      .get(url)
      .then((res) => {
        setCustomerLocations(res.data.customerLocations)
        setCustomerLocationsCopy(res.data.customerLocations)
      })
      .catch((e) => {
        setHasLoadError(e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const saveCustomerLocations = (id) => {
    const baseUrl = `/api/customer/${id || customerId}/location`
    return authedAxios
      .put(
        baseUrl,
        customerLocations.map((l) => ({ ...l, id: l.isNew ? undefined : l.id }))
      )
      .then((res) => {
        setCustomerLocationsCopy(customerLocations)
        return res
      })
  }

  const reset = () => {
    setCustomerLocations(customerLocationsCopy)
  }

  const removeLocation = (location) => {
    setCustomerLocations((prev) => prev.filter((l) => l !== location))
  }

  const deleteLocation = (location) => {
    if (!location.isNew)
      return authedAxios.delete(baseUrl + `/${location.id}`).then((res) => {
        removeLocation(location)
        return res
      })

    removeLocation(location)
    return Promise.resolve()
  }

  useEffect(() => {
    setIsLoading(true)
    getCustomerLocations()
  }, [customerId, queryString])

  const primaryLocation = customerLocations.find((l) => l.isDefault)

  return {
    customerLocations,
    primaryLocation,
    isLoading,
    hasLoadError,
    setCustomerLocations,
    saveCustomerLocations,
    reset,
    deleteLocation,
  }
}

export default useCustomerLocations
